import { getDocuments } from "@/common/service/documentsService";

export default {
  namespaced: true,

  // initial state
  state: {
    documents: []
  },

  //mutations
  mutations: {
    setDocuments(state, documents) {
      state.documents = documents;
    }
  },

  //actions
  actions: {
    async loadDocuments({ commit, dispatch }) {
      dispatch("error/setError", null, { root: true });
      try {
        //const documents = await getDocuments();
        const documents = await getDocuments();

        commit("setDocuments", documents);
      } catch (error) {
        dispatch("error/setError", error, { root: true });
      }
    }
  },

  //getters
  getters: {
    documents: state => state.documents.pdfFiles,
    latestDocuments: state => state.documents.pdfFiles
  }
};
